import React from "react";
import { LEGAL_LAST_UPDATED } from "./legalMeta";

// Shared shell for the Privacy Policy and Terms of Service pages.
//
// Renders the Prigmar app icon in the page header (TikTok review
// requires the app icon to be visible at the top of both legal pages,
// in addition to the browser-tab favicon) and a footer that cross-links
// to the other legal page + home + support. Self-contained inline
// styles so the page renders consistently without depending on the
// app's CSS bundle.

const ICON = (process.env.PUBLIC_URL || "") + "/android-chrome-512x512.png";

const styles = {
  page: {
    color: "#1f2933",
    fontFamily: "Arial, Helvetica, sans-serif",
    lineHeight: 1.6,
    background: "#ffffff",
    minHeight: "100vh",
  },
  header: {
    borderBottom: "1px solid #e4e7eb",
    padding: "24px 20px 20px",
    maxWidth: 880,
    margin: "0 auto",
  },
  brand: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    textDecoration: "none",
    color: "#1f2933",
  },
  icon: { display: "block", borderRadius: 8 },
  brandName: { fontSize: 22, fontWeight: 700 },
  title: { margin: "18px 0 4px", fontSize: 28 },
  updated: { margin: 0, color: "#7b8794", fontSize: 14 },
  main: { maxWidth: 880, margin: "0 auto", padding: "8px 20px 48px" },
  footer: {
    borderTop: "1px solid #e4e7eb",
    maxWidth: 880,
    margin: "0 auto",
    padding: "20px",
    display: "flex",
    flexWrap: "wrap",
    gap: 20,
    fontSize: 14,
  },
  fLink: { color: "#2867d6", textDecoration: "none" },
};

const LegalLayout = ({ title, other, children }) => (
  <div style={styles.page}>
    <header style={styles.header}>
      <a href="/" style={styles.brand} aria-label="Prigmar home">
        <img src={ICON} alt="Prigmar logo" width={44} height={44} style={styles.icon} />
        <span style={styles.brandName}>Prigmar</span>
      </a>
      <h1 style={styles.title}>{title}</h1>
      <p style={styles.updated}>Last updated: {LEGAL_LAST_UPDATED}</p>
    </header>
    <main style={styles.main}>{children}</main>
    <footer style={styles.footer}>
      <a href="/" style={styles.fLink}>Home</a>
      <a href={other.href} style={styles.fLink}>{other.label}</a>
      <a href="mailto:support@prigmar.com" style={styles.fLink}>support@prigmar.com</a>
    </footer>
  </div>
);

export default LegalLayout;
